import React, { useState } from 'react';
import { useShop } from '../../foundation/index.js';
import { flattenConnection } from '../../utilities/index.js';
import { CartCreate, defaultCartFragment } from './cart-queries.js';
import { SHOPIFY_STOREFRONT_ID_HEADER, STOREFRONT_API_PUBLIC_TOKEN_HEADER, SHOPIFY_STOREFRONT_Y_HEADER, SHOPIFY_STOREFRONT_S_HEADER, SHOPIFY_Y, SHOPIFY_S, } from '../../constants.js';
import { parse } from 'worktop/cookie';
export function useCartFetch() {
    const { storeDomain, storefrontApiVersion, storefrontToken, storefrontId } = useShop();
    return React.useCallback(({ query, variables, }) => {
        const headers = {
            'Content-Type': 'application/json',
            'X-SDK-Variant': 'hydrogen',
            'X-SDK-Version': storefrontApiVersion,
            [STOREFRONT_API_PUBLIC_TOKEN_HEADER]: storefrontToken,
        };
        if (storefrontId) {
            headers[SHOPIFY_STOREFRONT_ID_HEADER] = storefrontId;
        }
        // Find Shopify cookies
        const cookieData = parse(document.cookie);
        if (cookieData[SHOPIFY_Y] && cookieData[SHOPIFY_S]) {
            headers[SHOPIFY_STOREFRONT_Y_HEADER] = cookieData[SHOPIFY_Y];
            headers[SHOPIFY_STOREFRONT_S_HEADER] = cookieData[SHOPIFY_S];
        }
        return fetch(`https://${storeDomain}/api/${storefrontApiVersion}/graphql.json`, {
            method: 'POST',
            headers,
            body: JSON.stringify({
                query: query.toString(),
                variables,
            }),
        })
            .then((res) => res.json())
            .catch((error) => {
            return {
                data: undefined,
                errors: error.toString(),
            };
        });
    }, [storeDomain, storefrontApiVersion, storefrontToken, storefrontId]);
}
export function useInstantCheckout() {
    const [cart, updateCart] = useState();
    const [checkoutUrl, updateCheckoutUrl] = useState();
    const [error, updateError] = useState();
    const fetch = useCartFetch();
    const createInstantCheckout = React.useCallback(async (cartInput) => {
        const { data, errors } = await fetch({
            query: CartCreate(defaultCartFragment),
            variables: {
                input: cartInput,
            },
        });
        if (errors) {
            updateError(errors);
            updateCart(undefined);
            updateCheckoutUrl(undefined);
        }
        if (data?.cartCreate?.cart) {
            const dataCart = data.cartCreate.cart;
            updateCart({
                ...dataCart,
                // @ts-expect-error While the cart still uses fragments, there will be a TS error here until we remove those fragments and get the type in-line
                lines: flattenConnection(dataCart.lines),
                note: dataCart.note ?? undefined,
            });
            updateCheckoutUrl(dataCart.checkoutUrl);
        }
    }, [fetch]);
    return { cart, checkoutUrl, error, createInstantCheckout };
}
